import React, { useEffect, useRef, useState } from 'react'
import { ActivityIndicator, View } from 'react-native'
import { TopNavigationBar } from 'ui/common/top-navigation-bar'
import { colors } from 'infra/color'
import { observer } from 'mobx-react'
import { alert, alertError, useSafeAreaInsets } from 'infra/util'
import { ButtonText } from 'ui/common/text'
import { BottomButton, BottomButtonContainer } from 'ui/discovery/bottom-button'
import { CategorySelectStore } from 'store/category-select'
import { categoryStore } from 'store/category'
import { UnreportedPlace } from 'infra/type'
import { navigation } from 'navigation/global'
import { reportUnknownPlace } from 'api/writes'
import { useMe } from 'api/hooks'
import { crawlMissing3rdParty } from 'infra/crawl-3rd-party'
import { PlaceAddEdit } from 'ui/common/place-add-edit.tsx'

export const PlaceReportScreen = observer(({ route }: { route: any }) => {
  const safeAreaInsets = useSafeAreaInsets()
  const bottomStartAt = safeAreaInsets.bottom + 48
  const store = useRef(new CategorySelectStore()).current
  const place: UnreportedPlace = route.params.data
  const { data: meData } = useMe()
  useEffect(() => {
    store.initData(categoryStore.raw)
  }, [store])
  const [isLoading, setIsLoading] = useState(false)
  return (
    <View
      style={{
        flex: 1,
        backgroundColor: colors.white,
        paddingTop: safeAreaInsets.top,
      }}
    >
      <TopNavigationBar title='장소 제보하기' />
      <PlaceAddEdit place={place} store={store} bottomStartAt={bottomStartAt} />
      <BottomButtonContainer style={{ bottom: bottomStartAt }}>
        <BottomButton
          onPress={() => {
            const leaf = store.leaf
            if (!leaf) return
            setIsLoading(true)
            // 부정확한 검색어 때문에 놓칠 수 있는 레퍼런스들을 장소 이름 기준으로 재수집
            crawlMissing3rdParty(place)
              .then((crawledPlace) => {
                return reportUnknownPlace(crawledPlace, [leaf])
              })
              .then((res) => {
                const placeId = res.data?.placeId
                if (!placeId) {
                  throw new Error('장소 제보 응답에 장소 ID가 없습니다.')
                }
                navigation.setRoot('HomeScreen', {
                  placeId,
                })
                alert(
                  '새로운 장소가 추가되었어요 🥳',
                  `감사드려요 🙏 ${meData?.nickname}님 덕분에 빠르고 쉬운 장소 탐색에 더 가까워졌어요!`,
                )
              })
              .catch((e) => {
                alertError(e)
                setIsLoading(false)
              })
          }}
          disabled={!store.selected.length || isLoading}
          style={{ width: 120, alignItems: 'center' }}
        >
          {!isLoading ? (
            <ButtonText>제보하기</ButtonText>
          ) : (
            <ActivityIndicator color={colors.white} size='small' />
          )}
        </BottomButton>
      </BottomButtonContainer>
    </View>
  )
})
